/* eslint react-hooks/exhaustive-deps: 0 */
import React, { useEffect } from "react";
import { useQuery, useClient, useMutation } from "jsonapi-react";
import _ from "lodash";
import DataTable from "react-data-table-component";
import { AppContext } from "../../context/AppContext";
//import { useBodyClass } from "../../helpers/utils";
import { FaCopy } from "react-icons/fa";
import ModalComponent from "../../components/common/ModalComponent/ModalComponent";
import { useToasts } from "react-toast-notifications";
import DISPLAY_TEXTS from "../../helpers/displayTexts";
import ModalRightComponent from "../../components/common/ModalRightComponent/ModalRightComponent";
import SearchBar from "../../components/common/Search/Search";
import ProfileCard from "../../components/ProfileCard/ProfileCard";
import {
  getCurrentWindowParams,
  checkModuleAddPermission,
  checkModuleDeletePermission,
  checkModuleEditPermission,
  formatTextWithFallback,
  trimDoubleSpace,
  validatorModule,
  checkModuleGeneralPermission,
} from "../../helpers/helpers";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { VW_ROUTES, apiRoutes } from "../../constants";
import ContextMenuContentWrapper from "../../components/common/ContextMenuContentWrapper";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { convertToFilterQuery, defaultSelectOption } from "../../helpers/utils";
import axios from "axios";
import PillText from "../../components/PillText/PillText";
import SiteFormComponent from "../../components/SiteFormComponent/SiteFormComponent";

const Sites = ({ location }) => {
  const history = useHistory();

  const initialState = {
    name: "",
  };

  const validationFormat = [
    {
      field: "name",
      preventCharacters: [","],
      minOneAlphabet: true,
      minLength: 3,
      isRequired: true,
      fieldName: "Site Name",
    },
    {
      field: "siteCode",
      isRequired: true,
      fieldName: "Site Code",
      preventCharacters: [","],
      minOneAlphabet: true,
      minLength: 3,
      maxLength: 20,
      isAlphaNumericWithUnderscoreHyphen: true,
    },
  ];
  const initialErrorState = {
    name: "",
    siteCode: "",
  };
  const { addToast } = useToasts();

  const {
    showRightModal,
    manageRightModal,
    showModal,
    manageModal,
    pagePermissions,
    initialPageParams,
    updateInitialPageParams,
    setPageUrlParams,
    isArchive,
    manageLoader,
    setProfilePageUrlParams,
    userRoleDetails,
  } = React.useContext(AppContext);
  //useBodyClass('modal-open');
  const [mode, setMode] = React.useState("");
  const [siteName, setSiteName] = React.useState("");
  const [siteCode, setSiteCode] = React.useState("");
  const [currentSiteId, setCurrentSiteId] = React.useState(0);
  const [currentSiteAddedProfiles, setCurrentSiteAddedProfiles] =
    React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const [searchQueryString, setSearchQueryString] = React.useState("");
  const [formState, updateFormState] = React.useState(initialState);
  const [showMobileDataFilter, setShowMobileDataFilter] = React.useState(false);

  const [intialDataLoaded, setInitialDataLoaded] = React.useState(false);

  const windowParams = getCurrentWindowParams();
  const pageNumber = windowParams.get("page");
  const [currentPageNumber, setCurrentPageNumber] = React.useState(
    Number(pageNumber) || 1,
  );

  const [resetPaginationDataTable, setResetPaginationDataTable] =
    React.useState(false);

  const [testData, setTestData] = React.useState();

  const [searchGoingOn, setSearchGoingOn] = React.useState(false);
  const [activePage, setactivePage] = React.useState(null);
  const [errorState, setErrorState] = React.useState(initialErrorState);
  const [createSite] = useMutation(apiRoutes.site);
  const [filterApplied, setFilterApplied] = React.useState(false);
  const [showSuccessModal, setShowSuccessModal] = React.useState(false);
  const [showSuccessMessage, setShowSuccessMessage] = React.useState("");
  const [disableExport, setdisableExport] = React.useState(true);
  const [deleteLoader, setDeleteLoader] = React.useState(false);

  const token = localStorage.getItem("access_token");

  const client = useClient();
  client.config.headers = {
    Authorization: `JWT ${token}`,
  };

  let paginationSettings;
  if (searchGoingOn) {
    paginationSettings = {
      number: 1,
      size: rowsPerPage,
    };
  } else {
    paginationSettings = {
      number: currentPageNumber,
      size: rowsPerPage,
    };
  }

  let initialSearchKey;
  const searchWord = window.location.hash.split("search=")[1];
  if (searchWord) {
    initialSearchKey = decodeURI(searchWord);
  } else {
    initialSearchKey = "";
  }

  const [filter, setFilter] = React.useState(
    initialSearchKey ? { search: initialSearchKey } : {},
  );
  const [profilesAdded, setProfilesAdded] = React.useState();

  const selectProfileLinked = (e) => {
    setProfilesAdded(e);
  };

  const sites = useQuery(
    activePage && [
      apiRoutes.site,
      {
        filter: filter,
        page: paginationSettings,
      },
    ],
    { client },
  );

  React.useEffect(() => {
    if (!sites.isFetching && !sites.isLoading) {
      if (sites?.data?.length === 0) {
        setdisableExport(true);
      } else {
        setdisableExport(false);
      }
      setInitialDataLoaded(true);
    } else {
      setInitialDataLoaded(false);
    }
  }, [sites]);

  React.useEffect(() => {
    if (location) {
      updateInitialPageParams(location);
    }
  }, []);

  const toggleResetPagination = () => {
    setResetPaginationDataTable((prevToggle) => !prevToggle);
  };

  const url = useLocation();

  const setSearchQueryFromURL = () => {
    const searchWord = windowParams.get("search");
    if (String(searchWord ?? "").length > 0)
      setSearchQueryString(decodeURI(searchWord));
    else setSearchQueryString("");
  };

  const setCurrentPageFromURL = () => {
    const pageNumber = windowParams.get("page");
    if (pageNumber && pageNumber > 0) {
      setCurrentPageNumber(Number(pageNumber));
      setactivePage(Number(pageNumber));
      toggleResetPagination();
    } else {
      setCurrentPageNumber(1);
      setactivePage(1);
      toggleResetPagination();
    }
  };

  useEffect(() => {
    setCurrentPageFromURL();
    setSearchQueryFromURL();
  }, [url]);

  // React.useEffect(() => {
  //   if (initialPageParams) {
  //     setCurrentPageNumber(Number(pageNumber));
  //     // setactivePage(initialPageParams.initialPageNumber);
  //     setactivePage(Number(pageNumber));
  //     setSearchQueryString(initialPageParams.initialSearchKey);
  //   }
  // }, [initialPageParams, pageNumber]);

  const getTestDataOptions = () => [
    defaultSelectOption(),
    { label: "Yes", value: 1 },
    { label: "No", value: 0 },
  ];

  const [updateSite] = useMutation(
    apiRoutes.siteUpdate.replace("{siteId}", currentSiteId),
    { method: "PUT", client },
  );
  const onInputChange = (e) => {
    if (e.target.name === "name" && errorState.name) {
      setErrorState({ ...errorState, name: "" });
    }
    if (e.target.name === "siteCode" && errorState.siteCode) {
      setErrorState({ ...errorState, siteCode: "" });
    }

    if (e.target.name === "name") {
      setSiteName(trimDoubleSpace(e.target.value?.toUpperCase()));
    }
    if (e.target.name === "siteCode") {
      setSiteCode(trimDoubleSpace(e.target.value?.toUpperCase()));
    }
    updateFormState({
      ...formState,
      [e.target.name]: trimDoubleSpace(e.target.value?.toUpperCase()),
    });
  };
  const manageModalSettings = (status) => {
    manageRightModal(status);
  };

  const deleteSiteDetails = async () => {
    setDeleteLoader(true);
    const { error } = await client.delete(
      apiRoutes.siteUpdate.replace("{siteId}", currentSiteId),
    );
    if (error === undefined) {
      setDeleteLoader(false);
      if (sites?.data?.length === 1 && currentPageNumber > 1) {
        paginationSettings = {
          number: currentPageNumber - 1,
          size: rowsPerPage,
        };
        setCurrentPageNumber(currentPageNumber - 1);
      } else {
        sites.refetch();
      }
      addToast(DISPLAY_TEXTS.SITE_DELETED, { appearance: "success" });
    } else {
      addToast(DISPLAY_TEXTS.SOMETHING_WRONG, { appearance: "warning" });
    }
    setCurrentSiteId(0);
    manageModal(false);
    setDeleteLoader(false);
  };

  const submitNewSite = async () => {
    let errors = errorValidate();

    setErrorState(errors);
    if (Object.keys(errors).length === 0) {
      if (formState.name !== "") {
        const { data, error } = await createSite(formState);
        if (data && error === undefined) {
          sites.refetch();
          addToast(DISPLAY_TEXTS.SITE_ADDED, { appearance: "success" });
          manageModalSettings(false);
          setSiteName("");
          setSiteCode("");
        } else if (error !== undefined && error.detail) {
          const errorMessage = error.detail.toLowerCase();
          const newErrorState = { ...errorState };

          if (errorMessage.includes("name already exists")) {
            newErrorState.name = "Site name already exists";
          }

          if (errorMessage.includes("code already exists")) {
            newErrorState.siteCode = "Site code already exists";
          }

          if (!newErrorState.name && !newErrorState.siteCode) {
            addToast(error.detail, { appearance: "error" });
          } else {
            setErrorState(newErrorState);
          }
        } else {
          addToast(DISPLAY_TEXTS.SOMETHING_WRONG, { appearance: "warning" });
        }
      }
    }
  };

  const updateSiteData = async () => {
    let errors = errorValidate();

    setErrorState(errors);
    if (Object.keys(errors).length === 0) {
      const { data, error } = await updateSite({
        ...formState,
        id: currentSiteId,
      });
      if (data && error === undefined) {
        sites.refetch();
        addToast(DISPLAY_TEXTS.SITE_UPDATED, { appearance: "success" });
        setMode("");
        manageModalSettings(false);
        setSiteName("");
        setSiteCode("");
      } else if (error !== undefined && error.detail) {
        const errorMessage = error.detail.toLowerCase();
        const newErrorState = { ...errorState };

        if (errorMessage.includes("name already exists")) {
          newErrorState.name = "Site name already exists";
        }

        if (errorMessage.includes("code already exists")) {
          newErrorState.siteCode = "Site code already exists";
        }

        if (!newErrorState.name && !newErrorState.siteCode) {
          addToast(error.detail, { appearance: "error" });
        } else {
          setErrorState(newErrorState);
        }
      } else {
        addToast(DISPLAY_TEXTS.SOMETHING_WRONG, { appearance: "warning" });
      }
    }
  };

  const addNewSite = () => {
    setMode("add");
    setSiteName("");
    setSiteCode("");
    updateFormState({
      name: "",
      siteCode: "",
    });
    setErrorState({
      name: "",
      siteCode: "",
    });
    manageRightModal(true);
  };

  const getSiteParam = (name) => {
    if (String(name ?? "").length) {
      const param = new URLSearchParams();
      param.append("site_name", name ?? "");
      return param.toString();
    }
    return "";
  };

  const updateSiteDetails = (id) => {
    setMode("edit");
    setCurrentSiteId(id);
    const exisitingData = _.keyBy(sites.data, "id")[id];
    setSiteName(exisitingData.name);
    setSiteCode(exisitingData.siteCode);
    updateFormState({
      name: exisitingData.name,
      siteCode: exisitingData.siteCode,
    });
    setErrorState({
      name: "",
      siteCode: "",
    });
    manageModalSettings(true);
  };

  const manageDeletedOption = (id, site) => {
    setCurrentSiteId(id);
    setCurrentSiteAddedProfiles(site.profilesAdded);
    manageModal(true);
  };

  const doCloseModal = () => {
    setCurrentSiteId(0);
    manageModal(false);
  };
  const errorValidate = () => {
    let errors = validatorModule(formState, validationFormat);

    return errors;
  };
  const customStyles = {
    headCells: {
      style: {
        fontWeight: "bold",
        fontSize: "14px",
      },
    },
  };
  const getEvent = (mode) => {
    if (mode.mode === "edit") {
      updateSiteDetails(mode.sites.id);
    }

    if (mode.mode === "delete") {
      manageDeletedOption(mode.sites.id, mode.sites);
    }

    if (mode.mode === "profileLink") {
      history.push(
        `${VW_ROUTES.ALL_PROFILES}?${getSiteParam(mode.sites?.name)}`,
      );
    }
  };

  let menuRef = React.useRef();
  React.useEffect(() => {
    document.addEventListener("mousedown", (event) => {
      if (
        event.target.className !== "user-role-action-icons" &&
        menuRef.current &&
        !menuRef.current.contains(event.target)
      ) {
        setTableUserId("");
      }
    });
  });
  const [tableUserId, setTableUserId] = React.useState("");
  const showHideContextMenu = (userid) => {
    setTableUserId(userid);
  };
  const renderProfileCard = (sites) => (
    <ProfileCard
      data={sites}
      mode="site"
      actions={userRoleDetails}
      actionsToParent={(mode) => getEvent({ mode, sites })}
      showTestData={checkModuleGeneralPermission(
        userRoleDetails,
        "organisation",
        "view_test_data",
        {},
        true,
      )}
    />
  );
  const showContextActionMenu = (site) => {
    const hasSiteEditPermission = checkModuleEditPermission(
      userRoleDetails,
      "site",
      "site",
      site,
    );

    const hasSiteDeletePermission = checkModuleDeletePermission(
      userRoleDetails,
      "site",
      "site",
      site,
    );
    return (
      (hasSiteEditPermission || hasSiteDeletePermission) && (
        <div className="contextMenu">
          {tableUserId === site.id && (
            <ContextMenuContentWrapper
              showContextMenu={tableUserId === site.id}
              handleContextMenuClose={() => setTableUserId("")}
            >
              <ul ref={menuRef}>
                {hasSiteEditPermission && (
                  <>
                    <li onClick={() => updateSiteDetails(site.id)}>
                      <button>
                        <i className="iconsminds-pen user-role-action-icons"></i>
                        Edit
                      </button>
                    </li>
                  </>
                )}
                {hasSiteDeletePermission && (
                  <li onClick={() => manageDeletedOption(site.id, site)}>
                    <button>
                      <i className="simple-icon-trash user-role-action-icons delete"></i>
                      Delete
                    </button>
                  </li>
                )}
              </ul>
            </ContextMenuContentWrapper>
          )}
          <span
            className="user-role-action-icons"
            onClick={() => showHideContextMenu(site.id)}
          >
            <i></i>
          </span>
        </div>
      )
    );
  };

  const columns = [
    {
      name: "Site Name",
      selector: (row) => row["name"],
      sortable: true,
      cell:
        Object.keys(userRoleDetails?.modulePermissions["site"] ?? {})?.length >
        0
          ? renderProfileCard
          : "",
    },
    {
      name: "Site Code",
      maxWidth: 250,
      minWidth: 250,
      selector: (row) => row["siteCode"],
      sortable: true,
      center: false,
      cell: (sites) => {
        const handleCopy = async (text) => {
          try {
            await navigator.clipboard.writeText(text);
            addToast("Copied to clipboard!", {
              appearance: "success",
              autoDismiss: true,
            });
          } catch (err) {
            addToast("Failed to copy!", {
              appearance: "error",
              autoDismiss: true,
            });
          }
        };

        return (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ gap: "8px", padding: "8px 0" }}
          >
            {sites.siteCode && (
              <FaCopy
                onClick={(e) => {
                  e.stopPropagation();
                  handleCopy(sites.siteCode);
                }}
                style={{
                  cursor: "pointer",
                  opacity: 0.7,
                  flexShrink: 0,
                  alignSelf: "center",
                }}
                title="Copy to clipboard"
                className="text-muted"
              />
            )}
            <span style={{ marginLeft: "4px" }}>
              {formatTextWithFallback(sites.siteCode)}
            </span>
          </div>
        );
      },
      hide: "md",
    },

    {
      name: "Test Data",
      sortable: false,
      maxWidth: "300px",
      hide: "md",
      omit: !checkModuleGeneralPermission(
        userRoleDetails,
        "organisation",
        "view_test_data",
        {},
        true,
      ),
      cell: (site) => (
        <PillText
          label={site?.isTestSite ? "Yes" : "No"}
          type={site?.isTestSite ? "active" : "inactive"}
          mapper={{ active: "Yes", inactive: "No" }}
        />
      ),
    },

    {
      name: "Actions",
      sortable: false,
      maxWidth: 100,
      minWidth: 100,
      center: true,
      cell: (site) => (
        <div className="actionColumn j-flx-end">
          {site.profilesAdded > 0 && (
            <Link
              to={`${VW_ROUTES.ALL_PROFILES}?${getSiteParam(site?.name)}`}
              title="View linked profiles"
            >
              <span className="iconsminds-link user-role-action-icons edit"></span>
            </Link>
          )}
          {showContextActionMenu(site)}
        </div>
      ),
      hide: "md",
      right: true,
    },
  ];

  let paginationGoing = false;
  const onChangePage = (page) => {
    setSearchGoingOn(false);
    paginationGoing = true;
    setCurrentPageNumber(page);
    const setParams = {
      page: page,
      searchQueryString: searchQueryString,
      initialPageParams: initialPageParams,
    };
    setPageUrlParams(setParams);
  };

  const onChangeRowsPerPage = (rows) => {
    setRowsPerPage(rows);
  };

  let searchGoing = false;
  const onSearchInputChange = (searchQuery) => {
    searchGoing = true;
    setSearchGoingOn(true);
    setSearchQueryString(searchQuery);
    setFilter({ ...filter, search: searchQuery });
    setactivePage(1);
    const setParams = {
      page: 1,
      searchQueryString: searchQuery,
      initialPageParams: initialPageParams,
    };
    setPageUrlParams(setParams);
  };

  window.onpopstate = (e) => {
    if (!searchGoing && !paginationGoing) {
      const searchWord = window.location.hash.split("search=")[1];
      const wordString = decodeURI(searchWord);
      if (searchWord) {
        setSearchQueryString(wordString);
        setFilter({ ...filter, search: wordString });
      } else {
        setSearchQueryString("");
        setFilter({ ...filter, search: "" });
      }

      const pageNumber = window.location.hash.split("page=")[1];
      if (pageNumber) {
        const pageFromUrl = pageNumber.split("&")[0];
        setCurrentPageNumber(Number(pageFromUrl));
      } else {
        setCurrentPageNumber(1);
      }
    } else {
      searchGoing = false;
      paginationGoing = false;
    }
  };
  const showFilter = (mode) => {
    setShowMobileDataFilter(mode);
  };

  const handleResetFilter = () => {
    for (let key of ["profiles_added", "profiles_added_gt", "test_data"]) {
      delete filter[key];
    }
    setTestData();
    setFilter({ ...filter });
    setProfilesAdded();
  };

  React.useEffect(() => {
    if (
      _.hasIn(filter, "profiles_added") ||
      _.hasIn(filter, "profiles_added_gt") ||
      _.hasIn(filter, "test_data")
    ) {
      setFilterApplied(true);
      return;
    }
    setFilterApplied(false);
  }, [filter]);

  const handleApplyFilter = () => {
    setCurrentPageNumber(1);
    showFilter(false);

    let updatedFilter = { ...filter };

    if (profilesAdded?.value == 0) {
      delete updatedFilter.profiles_added_gt;
      updatedFilter.profiles_added = 0;
    } else if (profilesAdded?.value == 1) {
      delete updatedFilter.profiles_added;
      updatedFilter.profiles_added_gt = 0;
    } else {
      delete updatedFilter.profiles_added;
      delete updatedFilter.profiles_added_gt;
    }
    const selectedTestData =
      testData?.value !== undefined && testData?.value !== ""
        ? testData?.value
        : null;

    if (selectedTestData !== null) {
      updatedFilter.test_data = selectedTestData;
    } else {
      delete updatedFilter.test_data;
    }
    setFilter(updatedFilter);
  };

  const closeReportSuccessPopup = () => {
    setShowSuccessModal(false);
    setShowSuccessMessage("");
  };

  const onExport = () => {
    manageLoader(true);
    let filterQuery = convertToFilterQuery(filter);

    const options = {
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: `JWT ${token}`,
      },
      url: `${apiRoutes.siteListExport}?${filterQuery}`,
    };
    axios(options)
      .then((response) => {
        manageLoader(false);
        setShowSuccessModal(true);
        setShowSuccessMessage(response.data.data.message);
      })
      .catch((error) => {
        manageLoader(false);
        addToast(DISPLAY_TEXTS.SOMETHING_WRONG, {
          appearance: "error",
        });
      });
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-header">
            <h1>Sites</h1>
            <div className="applicantFilter">
              <div className="desktopSearch">
                <SearchBar
                  onSearchInputChange={onSearchInputChange}
                  popstateText={searchQueryString}
                />
              </div>
              <div
                className={
                  showMobileDataFilter ? "table-filter active" : "table-filter"
                }
              >
                <div
                  className="filter-hide"
                  onClick={() => showFilter(false)}
                ></div>
                <div className="filter-form">
                  <div className="mobile-search">
                    <SearchBar
                      onSearchInputChange={onSearchInputChange}
                      popstateText={searchQueryString}
                    />
                  </div>
                </div>
              </div>

              {checkModuleAddPermission(userRoleDetails, "site", "site") && (
                <button
                  type="button"
                  title="Add Site"
                  className="tableFilterButton rightAlign btn-secondary"
                  onClick={() => addNewSite()}
                >
                  <>+</>
                </button>
              )}
              {checkModuleGeneralPermission(
                userRoleDetails,
                "site",
                "export_site_list",
              ) && (
                <button
                  onClick={onExport}
                  className="btn btn-secondary rounded-0 ml-2"
                  disabled={disableExport}
                >
                  Export
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12 col-md-12 mb-4">
          <div className="card">
            <div
              className={
                sites.isLoading || sites.isFetching || !intialDataLoaded
                  ? "card-body dataTableOuter table-loader"
                  : "card-body dataTableOuter"
              }
            >
              <DataTable
                subHeader={true}
                progressPending={
                  sites.isLoading || sites.isFetching || !intialDataLoaded
                }
                progressComponent={<p>&nbsp;</p>}
                columns={columns}
                data={sites.data}
                customStyles={customStyles}
                paginationServer={true}
                striped={true}
                onChangePage={onChangePage}
                onChangeRowsPerPage={onChangeRowsPerPage}
                pagination={true}
                paginationPerPage={rowsPerPage}
                paginationTotalRows={sites.meta && sites.meta.pagination.count}
                paginationDefaultPage={activePage}
                paginationResetDefaultPage={resetPaginationDataTable}
              />
            </div>
          </div>
        </div>
      </div>

      <ModalComponent
        show={showModal}
        header={<b>Confirm Delete</b>}
        content={
          <>
            <p>Are you sure you want to delete the selected Site details ?</p>
            {currentSiteAddedProfiles > 0 && (
              <p>
                Please note: {currentSiteAddedProfiles} profiles are linked to
                this site{" "}
              </p>
            )}
          </>
        }
        onSubmitCallback={deleteSiteDetails}
        onCloseCallback={doCloseModal}
        submitButtonText="Delete"
        isLoaderActive={deleteLoader}
        customClass="delete"
      />

      <ModalRightComponent
        show={showRightModal}
        header={mode === "add" ? "Add Site" : "Update Site"}
        submitButtonText={mode === "add" ? "Submit" : "Update"}
        classes="normal-right-modal"
        content={
          <SiteFormComponent
            title={
              mode === "add"
                ? 'Submitting below form will add "a new site".'
                : 'Submitting below form will update "the site".'
            }
            siteName={siteName}
            siteCode={siteCode}
            errorState={errorState}
            updateInputChange={onInputChange}
          />
        }
        onSubmitCallback={() =>
          mode === "add" ? submitNewSite() : updateSiteData()
        }
        onCloseCallback={() => {
          manageModalSettings(false);
          setSiteName("");
          setSiteCode("");
          updateFormState({
            name: "",
            siteCode: "",
          });
        }}
      />
      <div className={`reportStatusPopup ${showSuccessModal ? "show" : ""}`}>
        <div className="popUp">
          <div className="content">{showSuccessMessage}</div>
          <div className="action">
            <button
              className="btn btn-secondary"
              onClick={closeReportSuccessPopup}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Sites;
